var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerClassic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 0H32C14.375 0 0 14.375 0 32V400C0 408.875 7.125 416 16 416H432C440.875 416 448 408.875 448 400V32C448 14.375 433.625 0 416 0ZM80 356C69 356 60 347 60 336S69 316 80 316S100 325 100 336S91 356 80 356ZM384 344C384 348.375 380.375 352 376 352H232C227.625 352 224 348.375 224 344V328C224 323.625 227.625 320 232 320H376C380.375 320 384 323.625 384 328V344ZM384 224C384 241.625 369.625 256 352 256H96C78.375 256 64 241.625 64 224V96C64 78.375 78.375 64 96 64H352C369.625 64 384 78.375 384 96V224ZM32 512H416V448H32V512Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerClassic);
export default __webpack_public_path__ + "static/media/computer-classic.2ce7c2cba1e7c99d2361292f4fd9eb4e.svg";
export { ForwardRef as ReactComponent };